import React, { useState, useEffect } from "react";
import {
  chartLineColor,
  chartMarkerSymbols,
  chartMarkerSymbolsVariation,
  chartParams,
  dtickFormat,
} from "../../../utils/constants";
import Plot from "../../../utils/customPlotly";
import moment from "moment";

export default function TrendsPlotChart({
  xValues,
  yValues,
  title,
  colorIndex = 0,
  benchmarkScores = [],
}) {
  const [data, setData] = useState([]);

  const benchMarkLines = [
    {
      color: "#D91A60",
    },
    {
      color: "#004D40",
    },
    { color: "rgb(255,128,14)" },
    { color: "rgb(171,171,171)" },
    { color: "rgb(89,89,89)" },
    { color: "rgb(95,158,209)" },
    { color: "rgb(200,82,0)" },
    { color: "rgb(137,137,137)" },
    { color: "rgb(162,200,236)" },
    { color: "rgb(255,188,121)" },
    { color: "rgb(207,207,207)" },
  ];

  const manageDatesYearWise = (dates, scoreElement) => {
    const result = dates.reduce((acc, date, index) => {
      const year = moment(date).format("YYYY");
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year].push(index);
      return acc;
    }, {});

    let years = Object.keys(result);

    // if (years.length != scoreElement.length) {
    //   years = scoreElement.map((k) => k.year).sort();
    // }

    //     console.log(
    //       "firstfff",
    //       scoreElement,
    // "secc"
    //       ,
    //       years
    //         .map((k) => [
    //           scoreElement.find((f) => f.year == k),
    //           scoreElement.find((f) => f.year == k),
    //         ])
    //         .flat()
    //     );

    console.log({ years, scoreElement });

    const mainObj = {
      x: years
        .map((k) => [
          moment()
            .year(k)
            .startOf("year")
            .add(1, "second")
            .toDate(),
          moment()
            .year(k)
            .endOf("year")
            .subtract(1, "second")
            .toDate(),
        ])
        .flat()
        .filter((x, i) =>
          scoreElement.find(
            (f) =>
              f.year == moment(x).format("YYYY") ||
              parseInt(f.year) - 1 == moment(x).format("YYYY") ||
              parseInt(f.year) + 1 == moment(x).format("YYYY")
          )
        ),
      scores: years
        .map((k, i) => [
          scoreElement.find(
            (f) =>
              f.year == k ||
              parseInt(f.year) - 1 == k ||
              parseInt(f.year) + 1 == k
          ),
          scoreElement.find(
            (f) =>
              f.year == k ||
              parseInt(f.year) - 1 == k ||
              parseInt(f.year) + 1 == k
          ),
        ])
        .flat()
        .filter((v) => v)
        .map((y) => y && y.score),
      names: years
        .map((k, i) => [
          scoreElement.find(
            (f) =>
              f.year == k ||
              parseInt(f.year) - 1 == k ||
              parseInt(f.year) + 1 == k
          ),
          scoreElement.find(
            (f) =>
              f.year == k ||
              parseInt(f.year) - 1 == k ||
              parseInt(f.year) + 1 == k
          ),
        ])
        .flat()
        .filter((v) => v)
        .map((y) => y && y.name),
    };

    console.log({ mainObj });

    return mainObj;
  };

  useEffect(() => {
    const data = [
      {
        name: title,
        x:
          xValues.length == 1
            ? xValues.map((k) =>
                moment(k)
                  .startOf("day")
                  .toDate()
              )
            : xValues.map((k) => moment(k).toDate()), // X-axis data
        y: yValues.map((k) => k / 100), // Y-axis data
        // text: yValues.map((y,idx) => `${benchmarkScores[idx] ? `Benchmark: ${benchmarkScores[idx]}%`:""} `), // Display y values with "+ abc"
        textposition: "top", // Position of text on the chart
        // hovertemplate: "%{y}  <extra></extra>", // Customize hover tooltip
        mode: "markers+lines", // 'markers' for scatter, 'lines' for line chart
        type: "scatter",
        lines: "scatter",
        // line: chartLineMarkerGenerator(chartLineColor(colorIndex), "line"),
        line: chartLineMarkerGenerator('"rgb(0, 107, 164)"', "line"),
        marker: chartLineMarkerGenerator(
          // chartLineColor(colorIndex),
          '"rgb(0, 107, 164)"',
          "marker",
          xValues.length
        ),
      },
    ];

    console.log({ data });

    if (benchmarkScores.length) {
      for (let index = 0; index < benchmarkScores.length; index++) {
        const scoreElement = benchmarkScores[index];

        const color = benchMarkLines[index].color || "black";

        const xYears = Array.from(
          new Set(xValues.map((k) => moment(k).format("YYYY")))
        ).sort();

        console.log(xYears);

        const xArray = xYears
          .map((c) => [
            moment(c, "YYYY").startOf("year").add(1,"second").toDate(),
            moment(c, "YYYY").endOf("year").subtract(1,"second").toDate(),
          ])
          .flat();

          function findDocumentByNameAndYear(data, name, year) {
            // Filter documents matching the given name
            const matchingNameDocs = data.filter(doc => doc.name === name);
        
            if (matchingNameDocs.length === 0) {
                return null; // No documents found for the given name
            }
        
            // Sort documents by year
            matchingNameDocs.sort((a, b) => parseInt(a.year) - parseInt(b.year));
        
            // Find the exact year match
            const exactMatch = matchingNameDocs.find(doc => parseInt(doc.year) === year);
        
            if (exactMatch) {
                return exactMatch;
            }
        
            // Find the nearest year document
            let nearestDoc = null;
            let minDiff = Infinity;
        
            for (const doc of matchingNameDocs) {
                const docYear = parseInt(doc.year);
                const diff = Math.abs(docYear - year);
        
                if (diff < minDiff) {
                    minDiff = diff;
                    nearestDoc = doc;
                }
            }
        
            return nearestDoc;
        }

        const yArray = xYears.map((c) => {
          const doc = findDocumentByNameAndYear(scoreElement,scoreElement[0].name,parseInt(c));

          return [doc.score,doc.score]
        }).flat();

  
        data.push({
          name: `Benchmark ${scoreElement[0].name}`,
          x: xArray, // X-axis data
          y: yArray.map(k => k/100), // Y-axis data
          text: xValues ? xValues.map((x) => `${scoreElement[0].name}`) : [],
          textposition: "top", // Position of text on the chart
          hovertemplate: "Benchmark: %{y}<extra></extra>", // Customize hover tooltip
          mode: "markers+lines", // 'markers' for scatter, 'lines' for line chart
          type: "scatter",
          lines: "scatter",
          line: chartLineMarkerGenerator(color, "benchmark"),
          marker: chartLineMarkerGenerator(color, "marker", xArray.length),
        });
      }
    }

    // if (benchmarkScores.length) {
    //   for (let index = 0; index < benchmarkScores.length; index++) {
    //     const scoreElement = benchmarkScores[index];

    //     const dateYearNameData = manageDatesYearWise(xValues, scoreElement);
    //     const color = benchMarkLines[index].color || "black";
    //     data.push({
    //       name: `Benchmark ${
    //         dateYearNameData.names && dateYearNameData.names[0]
    //           ? dateYearNameData.names[0]
    //           : ""
    //       }`,
    //       x: dateYearNameData.x
    //         ? dateYearNameData.x.map((k) =>
    //             moment(k)
    //               .add(1, "second")
    //               .toDate()
    //           )
    //         : [], // X-axis data
    //       y: dateYearNameData.scores
    //         ? dateYearNameData.scores.map((k) => k / 100)
    //         : [], // Y-axis data
    //       text: dateYearNameData.names
    //         ? dateYearNameData.names.map((x) => `${x}`)
    //         : [],
    //       textposition: "top", // Position of text on the chart
    //       hovertemplate: "%{text} Benchmark: %{y}<extra></extra>", // Customize hover tooltip
    //       mode: "markers+lines", // 'markers' for scatter, 'lines' for line chart
    //       type: "scatter",
    //       lines: "scatter",
    //       line: chartLineMarkerGenerator(color, "benchmark"),
    //       marker: chartLineMarkerGenerator(color, "marker", xValues.length),
    //     });
    //   }
    // }

    setData(data);
  }, [benchmarkScores, yValues]);

  const chartLineMarkerGenerator = (color, type, length) => {
    // let value = Math.floor(Math.random()*16777215).toString(16)
    // let color = `#${value}`.toUpperCase();
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else if (type === "benchmark") {
      obj = {
        color,
        width: 1,
        dash: "dot",
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color: [...Array(length).fill(color)],
        size: 10,
        // symbol: ,
      };
    }
    return obj;
  };

  const layout = {
    title: title,
    xaxis: {
      showline: false,
      linecolor: "white",
      gridcolor: "white",
      ticks: "outside",
      ticklabelposition: "outside bottom",
      type: "date",
      // range: xValues &&  xValues.length ? [
      //   moment(xValues[0]).format("YYYY-MM-DD"),
      //   moment(xValues[xValues.length - 1]).format("YYYY-MM-DD"),
      // ]:[],
      tickformat: "%b %d<br>%Y",
      dtick:
        xValues &&
        xValues.length &&
        dtickFormat(
          moment(xValues[0]).format("YYYY-MM-DD"),
          moment(xValues[xValues.length - 1]).format("YYYY-MM-DD")
        ),
      showgrid: true,
      zerolinecolor: "white",
      zerolinewidth: 1.2,
      gridwidth: 1.2,
      margin: {
        pad: 20,
      },
      tickfont: { color: "#313236" },
      automargin: true,
      ticks: "outside",
      ticklabelposition: "outside bottom",
    },
    margin: {
      b: 30,
      t: 30,
    },
    yaxis: {
      gridcolor: "white",
      range: [-0.05, 1.1],
      tickformat: "%",
      zerolinecolor: "#ffffff",
    },
    showlegend: true,
    autosize: true,
    uirevision: true,
    legend: chartParams({ kpiData: xValues }, "legend"),
    paper_bgcolor: "white",
    plot_bgcolor: "#e5ecf694",
  };

  console.log({ layout });
  return (
    <div className="trends-plot-container">
      <Plot
        data={data}
        layout={layout}
        config={{
          displayModeBar: "hover", // Make sure the toolbar is shown
          responsive: true, // Chart is responsive
        }}
        style={{ width: "100%", height: "100%" }} // Responsive size
      />

      <style>
        {`
            .legend { 
              visibility: ${benchmarkScores.length ? "visible" : "hidden"}; 
            }
          `}
      </style>
    </div>
  );
}
